<template>
    <div class="container">
        <h2>Add Products</h2>
        <p class="info">
            Select a product line to the left to display individual products for selection. <br>
            Multiple products can be selected or deselected without altering the submittal by clicking the checkboxes below.
        </p>
    </div>
</template>

<script>
    export default {
        props: ['project']
    }
</script>